/**
 * Định nghĩa các cột fix cứng dùng chung trên chương trình
 */
export default {
  amountOc: 'amount_oc',
  amount: 'amount',
  debitAccount: 'debit_account',
  creditAccount: 'credit_account',
  taxAccount: 'tax_account', // Tài khoản thuế
  cogsAccount: 'cogs_account', // Tài khoản giá vốn
  inventoryAccount: 'inventory_account', // Tài khoản kho
  budgetSourceId: 'budget_source_id',
  cashWithdrawTypeId: 'cash_withdraw_type_id',
  methodDistributeType: 'method_distribute_type',
  orgRefDetailId: 'org_ref_detail_id', //Thông tin trường đánh dấu chứng từ detail gốc sinh ra dòng hạch toán
  refDetailId: 'ref_detail_id', //Thông tin trường là khóa chi tiết chứng từ map với orgRefDetailId ở trên
  sign: 'sign', //Trường ghi chú trong quy tắc hạch toán đồng thời chi tiết (Ghi âm, ghi dương)

  //Các cột bổ sung check thêm để show cảnh báo rule hạch toán đồng thời không phù hợp với quy tắc
  budgetChapterCode: 'budget_chapter_code',
  budgetSubKindItemCode: 'budget_sub_kind_item_code',
  budgetItemCode: 'budget_item_code',
  budgetSubItemCode: 'budget_sub_item_code',
  budgetDetailItemCode: 'budget_detail_item_code',
  projectCode: 'project_code',
  topicCode: 'topic_code',
  budgetFeesCode: 'budget_fees_code',
  taskCode: 'task_code',
};
